module.exports = __webpack_public_path__ + "202669:9205d1a92be8207f1496/img/featured-section@1x.02a824a.gif";